import React, { useContext, useCallback, useState, useEffect, useMemo } from 'react'
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { TranslatorContext } from '@jutro/locale';
import { ViewModelForm, useDataRefresh, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import messages from './PlumbingComponent.messages';
import metadata from './PlumbingComponent.metadata.json5';
import styles from '../Construction.module.scss';

/**
 * 2024-07-24 - Debra Frum - US26831 - TFPA Res Quote - Construction - Plumbing - HomeOwners
 *                           US26826 - TFPA Res Quote - Construction - Plumbing - Dwelling
 * 
 * @param {*} props 
 * @returns 
 */

function PlumbingComponent(props) {
    const { submissionVM, updateWizardData, showErrors, findInvalidComponent, onValidate} = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const { onValidate: setComponentValidation, isComponentValid } = useValidation('Plumbing');
    const [plumbingUpdatedCheckBox, setPlumbingUpdatedCheckBox] = useState(false);
    const { refreshData } = useDataRefresh();
    const constructionPath = 'lobData.homeowners_tfpa.coverables.construction';
    const construction = _.get(submissionVM, constructionPath);
    const policyType = _.get(submissionVM, constructionPath);

    const getPlumbingType = useMemo(() => {
        const UpgradeTypeList = viewModelService?.productMetadata?.get('pc').types.getTypelist('PlumbingType_HOE');
        const formattedTypes =  UpgradeTypeList?.codes.map((code) => ({
                code: code.code,
                name: translator({ id: code.name })
            }))
        return formattedTypes
    },[translator, viewModelService?.productMetadata]);

    useEffect(() => {
        const plumbingUpgradeExists = _.get(construction, 'plumbingUpgradeExists.value') === true;
        _.set(construction,`plumbingUpgradeExists.value`, plumbingUpgradeExists);
        setPlumbingUpdatedCheckBox(plumbingUpgradeExists);

    },[])

   useEffect(() => {
        if (onValidate && !_.isNull(isComponentValid)) {
            onValidate(isComponentValid, 'Plumbing');
        }
    }, [isComponentValid, onValidate]);

    useEffect(() => {
        findInvalidComponent(isComponentValid, 'Plumbing');
    }, [findInvalidComponent, isComponentValid])

    const writeValue = useCallback(
        (value, path) => {         
            if (path === 'plumbingType') {
                _.set(construction,`plumbingTypeDescription.value`, undefined );
            }
            if (path === 'plumbingUpgradeExists') {
               value ? setPlumbingUpdatedCheckBox(true) : setPlumbingUpdatedCheckBox(false);
                _.set(construction,`plumbingUpgradeYear.value`, undefined );
            }
            _.set(submissionVM, constructionPath.concat('.').concat(path), value);
            updateWizardData(submissionVM);
            refreshData();
        }, [refreshData, submissionVM, updateWizardData]
    );

    const overrideProps = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
            showRequired: true
        },
        plumbingType: {
            visible: true,
            availableValues: getPlumbingType
        },
        plumbingTypeDescription: {
            visible: construction.plumbingType?.value?.code === 'other'
        },
        plumbingUpdates: {
            visible: true
        },
        plumbingUpdateYear: {
            visible: construction.plumbingUpgradeExists?.value
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {}
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            model={construction}
            onValueChange={writeValue}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
            onValidationChange={setComponentValidation}
            showErrors={showErrors}
         />
    );
}

export default PlumbingComponent;